import styled from 'styled-components';

export const CreateVacancyPageWrapper = styled.div`
  height: 100%;
  & > div:first-child {
    margin-bottom: 16px;
  }
`;
